var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVolumeUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8pq2z7929a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13258",
    style: {
      fill: "#5d5d5d"
    },
    d: "M0 0h20v14H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40220",
    style: {
      clipPath: "url(#8pq2z7929a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 72330",
    d: "M10.1 0a.882.882 0 0 0-.645.273l-4.78 3.056H.918a.882.882 0 0 0-.645.271.881.881 0 0 0-.273.647v5.507a.88.88 0 0 0 .273.645.88.88 0 0 0 .645.272h3.757l4.776 3.056a.918.918 0 0 0 1.563-.645V.918a.884.884 0 0 0-.273-.645A.886.886 0 0 0 10.1 0",
    style: {
      fill: "#5d5d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 72331",
    d: "M67.541 24.091a3.7 3.7 0 0 0 0-4.066 3.3 3.3 0 0 0-1.613-1.333.8.8 0 0 0-.359-.072.892.892 0 0 0-.645.265.874.874 0 0 0-.272.652.772.772 0 0 0 .172.509 1.678 1.678 0 0 0 .416.359c.163.1.325.21.488.33a1.448 1.448 0 0 1 .416.509 2.023 2.023 0 0 1 0 1.634 1.443 1.443 0 0 1-.416.509c-.163.12-.325.23-.488.33a1.7 1.7 0 0 0-.416.359.773.773 0 0 0-.172.509.876.876 0 0 0 .272.652.894.894 0 0 0 .645.265.794.794 0 0 0 .359-.072 3.391 3.391 0 0 0 1.613-1.341",
    transform: "translate(-52.296 -15.061)",
    style: {
      fill: "#5d5d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 72332",
    d: "M73.447.983a1.035 1.035 0 0 0-.373-.072.882.882 0 0 0-.646.273.882.882 0 0 0-.272.645.91.91 0 0 0 .559.846 9.04 9.04 0 0 1 1.09.63 5.492 5.492 0 0 1 1.656 6.92 5.415 5.415 0 0 1-1.656 1.943 8.912 8.912 0 0 1-1.09.631.911.911 0 0 0-.559.846.884.884 0 0 0 .272.645.9.9 0 0 0 .66.273.991.991 0 0 0 .359-.072 7.071 7.071 0 0 0 3.227-2.7 7.343 7.343 0 0 0 0-8.1 7.073 7.073 0 0 0-3.227-2.7",
    transform: "translate(-58.366 -.738)",
    style: {
      fill: "#5d5d5d"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVolumeUp);
export default __webpack_public_path__ + "static/media/ic_volume_up.82c395520763350bf589babbaf583dd9.svg";
export { ForwardRef as ReactComponent };